import {
  seriesCacheKey,
  questionsCacheKey,
  resultCacheKey,
  reactionsResultsCacheKey,
  questionSessionsCacheKey,
} from '@mentimeter/core-hooks';

interface CacheKeyArgs {
  reactionResults: Parameters<typeof getReactionResultsCacheKey>[0];
  results: Parameters<typeof getResultsCacheKey>[0];
  slideDeck: Parameters<typeof getSlideDeckCacheKey>[0];
  slides: Parameters<typeof getSlidesCacheKey>[0];
  slideSessions: Parameters<typeof getSlideSessionsCacheKey>[0];
}

export function getPresentationSWRCacheKey<Key extends keyof CacheKeyArgs>(
  key: Key,
  args: CacheKeyArgs[Key],
): string {
  switch (key) {
    case 'reactionResults': {
      return getReactionResultsCacheKey(
        args as CacheKeyArgs['reactionResults'],
      );
    }
    case 'results': {
      return getResultsCacheKey(args as CacheKeyArgs['results']);
    }
    case 'slideDeck': {
      return getSlideDeckCacheKey(args as CacheKeyArgs['slideDeck']);
    }
    case 'slides': {
      return getSlidesCacheKey(args as CacheKeyArgs['slides']);
    }
    case 'slideSessions': {
      return getSlideSessionsCacheKey(args as CacheKeyArgs['slideSessions']);
    }
    default: {
      throw new Error(`Invalid cache key: ${key}`);
    }
  }
}

const DOMAIN = 'presentation';
const SLIDE_DECK = 'slide-deck';
const SLIDE = 'slide';
const SESSION = 'session';

interface SlideDeckCacheKeyArgs {
  slideDeckPublicKey: string;
}

type SlideDeckCacheKeyFn = ({
  slideDeckPublicKey,
}: SlideDeckCacheKeyArgs) => string;

interface SlideCacheKeyArgs {
  slideAdminKey: string;
}

type SlideCacheKeyFn = (args: SlideCacheKeyArgs) => string;

const getSlideDeckCacheKey: SlideDeckCacheKeyFn = ({ slideDeckPublicKey }) => {
  // TODO: Remove the `core-hooks` cache key.
  return seriesCacheKey(slideDeckPublicKey);
  return [DOMAIN, SLIDE_DECK, slideDeckPublicKey].join('/');
};

const getSlidesCacheKey: SlideDeckCacheKeyFn = ({ slideDeckPublicKey }) => {
  // TODO: Remove the `core-hooks` cache key.
  return questionsCacheKey(slideDeckPublicKey);
  return [DOMAIN, SLIDE_DECK, slideDeckPublicKey, 'slides'].join('/');
};

interface ResultsKeyArgs extends SlideCacheKeyArgs {
  session?: number | 'current';
}

type ResultsCacheKeyFn = (args: ResultsKeyArgs) => string;

const getResultsCacheKey: ResultsCacheKeyFn = ({
  slideAdminKey,
  session = 'current',
}) => {
  // TODO: Remove the `core-hooks` cache key.
  return resultCacheKey(slideAdminKey, session);
  return [DOMAIN, SLIDE, slideAdminKey, 'results', SESSION, session].join('/');
};

const getReactionResultsCacheKey: SlideCacheKeyFn = ({ slideAdminKey }) => {
  // TODO: Remove the `core-hooks` cache key.
  return reactionsResultsCacheKey(slideAdminKey);
  return [DOMAIN, SLIDE, slideAdminKey, 'reaction-results'].join('/');
};

const getSlideSessionsCacheKey: SlideCacheKeyFn = ({ slideAdminKey }) => {
  // TODO: Remove the `core-hooks` cache key.
  return questionSessionsCacheKey(slideAdminKey);
  return [DOMAIN, SLIDE, slideAdminKey, 'sessions'].join('/');
};
